// Bank Feeds controls per business, from /plaid/status permissions. No
// business (personal feeds) is always the caller's own; the server enforces it.
const has = (list, businessId) => (list || []).map(Number).includes(Number(businessId));

export function canViewBankFeeds(permissions, businessId) {
  if (!businessId || !permissions) return true;
  return has(permissions.view_business_ids, businessId);
}

export function canManageBankFeeds(permissions, businessId) {
  if (!businessId) return true;
  return Boolean(permissions) && has(permissions.manage_business_ids, businessId);
}

export const BANK_FEED_LEVELS = [
  { value: 'none', label: 'No access', permissions: [] },
  { value: 'view', label: 'View', permissions: ['bank_feeds.view'] },
  { value: 'manage', label: 'Manage', permissions: ['bank_feeds.manage'] },
];

export function bankFeedLevel(granted) {
  const g = granted || [];
  if (g.includes('bank_feeds.manage')) return 'manage';
  return g.includes('bank_feeds.view') ? 'view' : 'none';
}
